import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { listLabAudiences } from '~/services/LabService';

type ListLabAudiencesQuery = Parameters<typeof listLabAudiences>[0];

export const labAudienceQueryKeys = {
  all: ['lab-audiences'] as const,
  lists: () => [...labAudienceQueryKeys.all, 'list'] as const,
  list: (query: ListLabAudiencesQuery) => [...labAudienceQueryKeys.lists(), query] as const,
};

type Params = {
  query: ListLabAudiencesQuery;
  enabled?: boolean;
};

export function useListLabAudiences({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: labAudienceQueryKeys.list(query),
    queryFn: async ({ signal }) => listLabAudiences(query, { signal }),
    enabled,
    placeholderData: keepPreviousData,
  });
}
